import { type ComponentType, type ReactElement, type ReactNode } from 'react';

import { AccessDenied } from '../../components/access-denied';
import { t } from '../../lib/i18n';
import { useSessionRoles } from './use-session-roles';

/**
 * The superuser-only screens (owner decision 2026-10-13): «Ключі фіду»,
 * «Налаштування», «Тарифи», «Маркетплейс». A plain admin who types the
 * address gets <AccessDenied />, not the page — the menu hides the rows, and
 * api-node answers 403 on every endpoint behind them anyway.
 *
 * Sits INSIDE RequireAdmin, so the session is already an admin's; while the
 * profile is (re)loading nothing of the page renders.
 */
export function RequireSuperadmin({ children }: { children: ReactNode }) {
  const { isSuperadmin, isLoading } = useSessionRoles();

  if (isLoading) {
    return (
      <div role="status" className="py-10 text-center text-sm text-cf-ink-subtle">
        {t('admin.login.checking')}
      </div>
    );
  }
  if (!isSuperadmin) return <AccessDenied />;
  return <>{children}</>;
}

/** Route `component` for a superuser-only page. */
export function superadminOnly(Page: ComponentType): () => ReactElement {
  function SuperadminOnlyPage(): ReactElement {
    return (
      <RequireSuperadmin>
        <Page />
      </RequireSuperadmin>
    );
  }
  SuperadminOnlyPage.displayName = `SuperadminOnly(${Page.displayName ?? Page.name})`;
  return SuperadminOnlyPage;
}
